import { Col, Row } from 'react-bootstrap';
import React from 'react';
import LeftSide from '../main/left-side';
import Navbar from '../navigation/navbar';
import TitleCard from '../main/title-card';
import useTranslate from '../useTranslate';
import { Link } from 'react-router';
import OperationalContactBasicCard from './operational-contact-basic-card';
import OperationalContactAssignmentsCard from './operational-contact-assignments-card';
import { usingFeatureWriteAccess } from '../../util/usingFeatureAccess';
import { usePbSelector } from '../../store/pbStoreHooks';
import { useParams } from 'react-router-dom';

function OperationalContactEditWrapper() {
    const params = useParams();
    const strings = useTranslate('OperationalContactEdit');
    const selectedPartner = usePbSelector(
        (store) => store.partnerManager.selectedPartner
    );

    const hasWriteOperationalContacts = usingFeatureWriteAccess(
        selectedPartner,
        'GENERAL_OPERATIONAL_CONTACTS'
    );

    return (
        <Navbar nav>
            <Row>
                <LeftSide>
                    <TitleCard
                        title={strings.title}
                        left={{
                            content: (
                                <Link
                                    to="/operational-contacts"
                                    className={
                                        'icon icon-wew-arrow-left icon-sm'
                                    }
                                />
                            ),
                            title: strings.back,
                        }}
                    />
                </LeftSide>
                <Col xs={9} className="col-middle">
                    <OperationalContactBasicCard
                        contactId={Number(params.contact_id)}
                        hasWritePermission={hasWriteOperationalContacts}
                    />
                    <OperationalContactAssignmentsCard
                        contactId={Number(params.contact_id)}
                        hasWritePermission={hasWriteOperationalContacts}
                    />
                </Col>
            </Row>
        </Navbar>
    );
}

export default OperationalContactEditWrapper;
